import React, { useState, useEffect } from "react";
import { notification } from "antd";
import {
  createRegistroOperario,
  getUsuarios,
  getActividades,
  /* getSubactividades, */ getSecciones,
  getLotes,
  calcularHorasLabor,
} from "../services/api";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import NavigationBar from "../components/layout/Navbar";

import "../assets/styles/RegistroForm.css";
import {
  showLitrosAplicados,
  showKilosAplicados,
  shouldShowRendimiento,
} from "../utils/activityConfig";

const userAuthenticated = {
  role: "Supervisor",
};

const UNIDAD_MEDIDA_OPTIONS = [
  { value: "Hectáreas", label: "Hectáreas" },
  { value: "Kilogramos", label: "Kilogramos" },
  { value: "Litros", label: "Litros" },
  { value: "Metros", label: "Metros" },
  { value: "Unidad", label: "Unidad" },
];

const obtenerFechaActual = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const RegistroForm = () => {
  // --- NUEVOS ESTADOS PARA FILTRADO DINÁMICO ---
  const [seccionesOptions, setSeccionesOptions] = useState([]);
  const [lotesOptions, setLotesOptions] = useState([]);
  const [seccionSeleccionada, setSeccionSeleccionada] = useState(null);

  const [usuarios, setUsuarios] = useState([]);
  const [selectedOperarios, setSelectedOperarios] = useState([]);
  const [validated, setValidated] = useState(false);

  const [registro, setRegistro] = useState({
    usuario_id: [],
    fecha: obtenerFechaActual(),
    actividad_id: "",
    subactividades_id: [],
    seccion_id: "",
    lote_ids: [],
    hora_inicio: "07:30",
    hora_fin: "17:00",
    horas_labor: "",
    horas_lluvia: "",
    observaciones: "",
    cantidad_litros_aplicados: "",
    cantidad_kilos_aplicados: "",
    rendimiento: "",
    unidad_medida: "",
  });

  const [descuentoDesayuno, setDescuentoDesayuno] = useState(false);
  const [errorHoras, setErrorHoras] = useState("");
  const [horasLaborCalculadas, setHorasLaborCalculadas] = useState("");
  const [actividades, setActividades] = useState([]);
  const [lotes, setLotes] = useState([]);

  const handleSelectChange = (selectedOption, fieldName) => {
    setRegistro((prev) => ({
      ...prev,
      [fieldName]: selectedOption ? selectedOption.value : "",
    }));
  };

  // MANEJADOR DE CAMBIO DE SECCIÓN CORREGIDO
  const handleSeccionChange = async (selectedOption) => {
    setSeccionSeleccionada(selectedOption);
    setRegistro((prev) => ({
      ...prev,
      seccion_id: selectedOption ? selectedOption.value : "",
      lote_ids: [],
    }));

    setLotesOptions([]);
    if (selectedOption) {
      try {
        const lotesData = await getLotes(selectedOption.value);
        const options = lotesData.map((l) => ({
          value: l.id,
          label: l.nombre,
        }));
        setLotesOptions(options);
      } catch (err) {
        console.error("Error cargando lotes:", err);
      }
    }
  };

  useEffect(() => {
    getUsuarios().then((data) => {
      let filteredUsers;
      if (userAuthenticated.role !== "Admin") {
        filteredUsers = data.filter(
          (usuario) => usuario.rol !== "Admin" && usuario.rol !== "Supervisor",
        );
      } else {
        filteredUsers = data;
      }
      filteredUsers.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setUsuarios(filteredUsers);
    });

    getActividades().then((data) => {
      data.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setActividades(data);
    });

    // CARGA DE SECCIONES PARA SELECT-REACT
    getSecciones().then((data) => {
      const options = data.map((s) => ({ value: s.id, label: s.nombre }));
      setSeccionesOptions(options);
    });
  }, []);

  // Manejar la selección de operarios
  const handleOperariosChange = (selectedOptions) => {
    const operariosSeleccionados = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setSelectedOperarios(selectedOptions);
    setRegistro((prev) => ({ ...prev, usuario_id: operariosSeleccionados })); // Aquí nos aseguramos de asignar los IDs al estado
  };

  const validarHoras = () => {
    if (registro.hora_inicio && registro.hora_fin) {
      const [horaInicio, minutoInicio] = registro.hora_inicio.split(":");
      const [horaFin, minutoFin] = registro.hora_fin.split(":");

      const inicio = new Date();
      inicio.setHours(horaInicio, minutoInicio);

      const fin = new Date();
      fin.setHours(horaFin, minutoFin);

      if (fin <= inicio) {
        setErrorHoras("La hora de fin debe ser posterior a la hora de inicio.");
        return false;
      }
    }
    setErrorHoras("");
    return true;
  };

  // Recalcular horas laborables automáticamente
  const recalcularHorasLabor = async () => {
    try {
      // Solo calcular si tenemos hora inicio, fin y actividad
      if (
        !registro.hora_inicio ||
        !registro.hora_fin ||
        !registro.actividad_id
      ) {
        setHorasLaborCalculadas("");
        return;
      }

      const horasCalculadas = await calcularHorasLabor({
        horaInicio: registro.hora_inicio,
        horaFin: registro.hora_fin,
        horasLluvia: parseFloat(registro.horas_lluvia) || 0,
        actividad_id: parseInt(registro.actividad_id) || 0,
        descuento_desayuno: descuentoDesayuno,
      });

      setHorasLaborCalculadas(horasCalculadas);

      // Actualizar el campo horas_labor en el estado del registro
      setRegistro((prev) => ({
        ...prev,
        horas_labor: horasCalculadas,
      }));
    } catch (error) {
      console.error("Error al calcular horas laborables:", error);
      setHorasLaborCalculadas("");
    }
  };

  // Carga de actividades movida al efecto anterior para evitar duplicidad

  // Recalcular horas labor cuando cambien los valores relevantes
  useEffect(() => {
    recalcularHorasLabor();
  }, [
    registro.hora_inicio,
    registro.hora_fin,
    registro.horas_lluvia,
    registro.actividad_id,
    descuentoDesayuno,
  ]);

  // ELIMINADO - useEffect de subactividades ya no se necesita
  /*
  useEffect(() => {
    if (registro.actividad_id) {
      setRegistro((prev) => ({ ...prev, subactividades_id: [] }));
      getSubactividades(registro.actividad_id).then((data) => {
        data.sort((a, b) => a.nombre.localeCompare(b.nombre));
        setSubactividades(data);
      });
    } else {
      setSubactividades([]);
    }
  }, [registro.actividad_id]);
  */

  useEffect(() => {
    if (registro.seccion_id) {
      setRegistro((prev) => ({ ...prev, lote_ids: [] }));
      getLotes(registro.seccion_id).then((data) => {
        data.sort((a, b) => a.nombre.localeCompare(b.nombre));
        setLotes(data);
      });
    } else {
      setLotes([]);
    }
  }, [registro.seccion_id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRegistro((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ELIMINADO - Handler de subactividades ya no se necesita
  /*
  const handleSubactividadesChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setRegistro((prev) => ({
      ...prev,
      subactividades_id: selectedValues,
    }));
  };
  */

  const handleLotesChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setRegistro((prev) => ({
      ...prev,
      lote_ids: selectedValues,
    }));
  };

  // Validar que los datos del formulario sean correctos
  const validarFormulario = () => {
    if (!validarHoras()) {
      return false;
    }

    const operarios = registro.usuario_id;
    if (!operarios || operarios.length === 0) {
      notification.error({
        message: "Error de validación",
        description: "Debe seleccionar al menos un operario.",
      });
      return false;
    }

    // Validar litros solo si la actividad es Fumigación Foliar
    if (
      (registro.actividad_id === 1 || registro.actividad_id === 5) && // IDs de Fumigación Foliar
      !registro.cantidad_litros_aplicados
    ) {
      notification.error({
        message: "Error de validación",
        description: "Debe ingresar la cantidad de litros aplicados.",
      });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      if (!validarHoras()) {
        notification.error({
          message: "Error de validación",
          description: "La hora de inicio deber ser anterior a la hora de fin.",
          placement: "topRight",
        });
        return;
      }

      if (!registro.usuario_id || registro.usuario_id.length === 0) {
        notification.error({
          message: "Error de validación",
          description: "Por favor, seleccione al menos un operario.",
          placement: "topRight",
        });
        return;
      }

      let litrosDivididos = 0;
      let kilosDivididos = 0;

      // Dividir litros entre operarios si aplica
      if (registro.cantidad_litros_aplicados && selectedOperarios.length > 0) {
        litrosDivididos = (
          Number(registro.cantidad_litros_aplicados) / selectedOperarios.length
        ).toFixed(2);
      }

      // Dividir kilos entre operarios si aplica
      if (registro.cantidad_kilos_aplicados && selectedOperarios.length > 0) {
        kilosDivididos = (
          Number(registro.cantidad_kilos_aplicados) / selectedOperarios.length
        ).toFixed(2);
      }

      // Actualizar los campos con valores divididos
      if (litrosDivididos > 0 || kilosDivididos > 0) {
        setRegistro((prev) => ({
          ...prev,
          cantidad_litros_aplicados:
            litrosDivididos > 0
              ? litrosDivididos
              : prev.cantidad_litros_aplicados,
          cantidad_kilos_aplicados:
            kilosDivididos > 0 ? kilosDivididos : prev.cantidad_kilos_aplicados,
        }));
      }

      const registroConHoras = {
        ...registro,
        usuario_ids: Array.isArray(registro.usuario_id)
          ? registro.usuario_id
          : [registro.usuario_id],
        descuento_desayuno: descuentoDesayuno,
        horas_lluvia: Number(registro.horas_lluvia) / 60 || 0,
        cantidad_litros_aplicados:
          litrosDivididos > 0
            ? litrosDivididos
            : Number(registro.cantidad_litros_aplicados) || 0,
        cantidad_kilos_aplicados:
          kilosDivididos > 0
            ? kilosDivididos
            : Number(registro.cantidad_kilos_aplicados) || 0,
        rendimiento: Number(registro.rendimiento) || 0,
        arboles_por_operario: selectedOperarios.map((operario) => ({
          operarioId: operario.value,
          cantidadArboles: 0, // Campo eliminado - ya no se captura
        })),
      };

      if (
        !registroConHoras.usuario_ids ||
        !registro.actividad_id ||
        !registro.seccion_id /* || registro.lote_ids.length === 0*/
      ) {
        notification.warning({
          message: "Campos incompletos",
          description: " Por favor complete todos los campos obligatorios.",
        });
        return;
      }

      try {
        const respuesta = await createRegistroOperario(registroConHoras);
        notification.success({
          message: "Registro  Creado",
          description: "El registro se ha creado exitosamente.",
          placement: "topRight",
        });

        setRegistro((prev) => ({
          ...prev,
          usuario_id: [],
          cantidad_litros_aplicados: "",
          cantidad_kilos_aplicados: "",
        }));
        setSelectedOperarios([]);
        setValidated(false);
      } catch (error) {
        console.error("=== Error al crear registro ===", {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
        });
        notification.error({
          message: "Error al Crear Registro:",
          description:
            error.response?.data?.detalles ||
            error.response?.data?.error ||
            error.message,
          placement: "topRight",
        });
      }
    }
    setValidated(true);
  };

  return (
    <div className="page-background">
      <NavigationBar />
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="form-container mx-auto"
      >
        {/* Selección de Operarios */}

        <Form.Group>
          <Form.Label htmlFor="formUsuarios">Seleccionar Operarios:</Form.Label>
          <Select
            inputId="formUsuarios"
            value={selectedOperarios}
            options={usuarios.map((usuario) => ({
              value: usuario.id,
              label: `${usuario.nombre} ${usuario.apellido} - ${usuario.cedula}`,
            }))}
            onChange={handleOperariosChange}
            isMulti
            isClearable
            placeholder="Seleccionar operarios"
            isSearchable
          />
          <Form.Control.Feedback type="invalid">
            Por favor selecciona al menos un operario.
          </Form.Control.Feedback>
        </Form.Group>

        {/* Fecha */}

        <Form.Group>
          <Form.Label htmlFor="formFecha">Fecha:</Form.Label>
          <Form.Control
            id="formFecha"
            type="date"
            name="fecha"
            value={registro.fecha}
            max={obtenerFechaActual()}
            onChange={handleChange}
            required
          />
          <Form.Control.Feedback type="invalid">
            Por favor ingrese una fecha válida.
          </Form.Control.Feedback>
        </Form.Group>

        {/* Actividad */}

        <Form.Group>
          <Form.Label htmlFor="formActividad">Actividad:</Form.Label>
          <Select
            inputId="formActividad"
            name="actividad_id"
            options={actividades.map((actividad) => ({
              value: actividad.id,
              label: actividad.nombre,
            }))}
            value={
              actividades.find(
                (actividad) => actividad.id === Number(registro.actividad_id),
              )
                ? {
                    value: registro.actividad_id,
                    label: actividades.find(
                      (actividad) =>
                        actividad.id === Number(registro.actividad_id),
                    ).nombre,
                  }
                : null
            }
            onChange={(selectedOption) => {
              const selectedId = selectedOption ? selectedOption.value : "";
              setRegistro((prev) => ({
                ...prev,
                actividad_id: selectedId,
              }));
            }}
            isClearable
            isSearchable
            placeholder="Seleccionar actividad"
          />
          <Form.Control.Feedback type="invalid">
            Seleccione una actividad.
          </Form.Control.Feedback>
        </Form.Group>

        {/* ELIMINADO - Campo de subactividades ya no se necesita */}
        {/*
        <Form.Group>
          <Form.Label htmlFor="formSubactividad">Subactividades:</Form.Label>
          <Select
            inputId="formSubactividad"
            isMulti
            options={subactividades.map((subactividad) => ({
              value: subactividad.id,
              label: subactividad.nombre,
            }))}
            value={subactividades
              .filter((subactividad) =>
                registro.subactividades_id.includes(subactividad.id)
              )
              .map((subactividad) => ({
                value: subactividad.id,
                label: subactividad.nombre,
              }))}
            onChange={handleSubactividadesChange}
          />
          <Form.Control.Feedback type="invalid">
            Seleccione al menos una subactividad.
          </Form.Control.Feedback>
        </Form.Group>
        */}

        {/* Sección */}
        <Form.Group>
          <Form.Label htmlFor="formSeccion">Sección:</Form.Label>
          <Select
            inputId="formSeccion"
            options={seccionesOptions}
            value={seccionSeleccionada}
            onChange={handleSeccionChange}
            placeholder="Seleccionar sección"
            isClearable
            required
          />
          {/* Eliminamos el Form.Control que usaba 'secciones.map', eso causaba el error */}
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="formLote">Lotes:</Form.Label>
          <Select
            inputId="formLote"
            isMulti
            isSearchable={false}
            options={lotes.map((lote) => ({
              value: lote.id,
              label: lote.nombre,
            }))}
            value={lotes
              .filter((lote) => registro.lote_ids.includes(lote.id))
              .map((lote) => ({
                value: lote.id,
                label: lote.nombre,
              }))}
            onChange={handleLotesChange}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            menuShouldBlockScroll={true}
            placeholder="Seleccionar lotes"
            noOptionsMessage={() => "No se encontraron lotes"}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          <Form.Control.Feedback type="invalid">
            Seleccione al menos un lote.
          </Form.Control.Feedback>
        </Form.Group>

        {/* Lógica duplicada eliminada - ahora usa configuración centralizada */}

        {/* Campo de Litros Aplicados - para actividades específicas */}
        {showLitrosAplicados(Number(registro.actividad_id)) && (
          <>
            <Form.Group>
              <Form.Label htmlFor="formCantidadLitrosAplicados">
                Cantidad de litros aplicados:
              </Form.Label>
              <Form.Control
                id="formCantidadLitrosAplicados"
                type="number"
                name="cantidad_litros_aplicados"
                value={registro.cantidad_litros_aplicados}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
                step="0.01"
                min="0"
                placeholder="Ingrese la cantidad de litros aplicados"
                required
              />
            </Form.Group>

            {/* Mostrar cálculo de litros por operario si hay operarios seleccionados */}
            {selectedOperarios.length > 0 && (
              <p>
                <b>Total litros por operario:</b>{" "}
                {registro.cantidad_litros_aplicados &&
                selectedOperarios.length > 0
                  ? (
                      Number(registro.cantidad_litros_aplicados) /
                      selectedOperarios.length
                    ).toFixed(2)
                  : 0}{" "}
                litros.
              </p>
            )}
          </>
        )}

        {/* Campo de Kilos Aplicados - para actividades específicas */}
        {showKilosAplicados(Number(registro.actividad_id)) && (
          <>
            <Form.Group>
              <Form.Label htmlFor="formCantidadKilosAplicados">
                Cantidad de kilos aplicados:
              </Form.Label>
              <Form.Control
                id="formCantidadKilosAplicados"
                type="number"
                name="cantidad_kilos_aplicados"
                value={registro.cantidad_kilos_aplicados}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
                step="0.01"
                min="0"
                placeholder="Ingrese la cantidad de kilos aplicados"
                required
              />
            </Form.Group>

            {/* Mostrar cálculo de kilos por operario si hay operarios seleccionados */}
            {selectedOperarios.length > 0 && (
              <p>
                <b>Total kilos por operario:</b>{" "}
                {registro.cantidad_kilos_aplicados &&
                selectedOperarios.length > 0
                  ? (
                      Number(registro.cantidad_kilos_aplicados) /
                      selectedOperarios.length
                    ).toFixed(2)
                  : 0}{" "}
                kilos.
              </p>
            )}
          </>
        )}

        {/* Campos de Rendimiento y Unidad de Medida - se muestran según configuración */}
        {shouldShowRendimiento(Number(registro.actividad_id)) && (
          <>
            <Form.Group>
              <Form.Label htmlFor="formRendimiento">Cantidad:</Form.Label>
              <Form.Control
                id="formRendimiento"
                type="number"
                name="rendimiento"
                value={registro.rendimiento}
                onChange={handleChange}
                onWheel={(e) => e.target.blur()}
                step="0.01"
                min="0"
                placeholder="Ingrese la cantidad"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Unidad de Medida:</Form.Label>
              <Select
                options={UNIDAD_MEDIDA_OPTIONS}
                value={UNIDAD_MEDIDA_OPTIONS.find(
                  (opt) => opt.value === registro.unidad_medida,
                )}
                onChange={(option) =>
                  handleSelectChange(option, "unidad_medida")
                }
                placeholder="Seleccione unidad de medida"
              />
            </Form.Group>
          </>
        )}

        <Form.Group>
          <Form.Check
            type="checkbox"
            id="formDescuentoDesayuno"
            label="Descontar desayuno (08:00 - 08:30)"
            checked={descuentoDesayuno}
            onChange={(e) => setDescuentoDesayuno(e.target.checked)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="formHoraInicio">Hora Inicio:</Form.Label>
          <Form.Control
            id="formHoraInicio"
            type="time"
            name="hora_inicio"
            value={registro.hora_inicio}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="formHoraFin">Hora Fin:</Form.Label>
          <Form.Control
            id="formHoraFin"
            type="time"
            name="hora_fin"
            value={registro.hora_fin}
            onChange={handleChange}
            required
          />
          {errorHoras && <div className="text-danger mt-2">{errorHoras}</div>}
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="formHorasLluvia">Minutos de Lluvia:</Form.Label>
          <Form.Control
            id="formHorasLluvia"
            type="number"
            step="1"
            name="horas_lluvia"
            value={registro.horas_lluvia}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            min="0"
            max="600"
            placeholder="Ej: 20 para 20 minutos"
          />

          <Form.Text className="text-muted">
            Ingrese los MINUTOS perdidos por lluvia (ej: 20 minutos, 45 minutos,
            etc.)
          </Form.Text>
        </Form.Group>

        <Form.Group>
          <Form.Label htmlFor="formObservaciones">Observaciones:</Form.Label>
          <Form.Control
            id="formObservaciones"
            as="textarea"
            name="observaciones"
            value={registro.observaciones}
            onChange={handleChange}
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="submit-button">
          Crear Registro
        </Button>
      </Form>
    </div>
  );
};

export default RegistroForm;
